import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/_organization/billing/stripe-complete"
)({
  beforeLoad: () => {
    throw redirect({
      to: "/organization-settings/billing/stripe-complete",
      replace: true,
    })
  },
})
